import classNames from 'classnames';
import i18n from '@/settings/i18n';
import { useCollectionPageContext } from '../../hooks/useCollectionPageContext';
import { FilterType } from '../../hooks/types';

const t = i18n.init('collections');

const CategoryFilters = ({ className }: { className?: string }) => {
  const {
    filters,
    selectedFilters,
    toggleFilter,
    fixedFilters,
    clearCategoryFilters,
  } = useCollectionPageContext();
  const categories = filters?.categories ?? [];
  const selectedCategories = selectedFilters?.categories;

  if (categories.length <= 1) {
    return null;
  }

  return (
    <div className={classNames('overflow-hidden', className)}>
      <div
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="hide-scrollbar flex gap-x-1 overflow-x-auto"
      >
        <button
          onClick={() => clearCategoryFilters()}
          className={classNames(
            'h-8 shrink-0 whitespace-nowrap rounded-full border px-4 text-xs hover:border-gray-700 disabled:cursor-not-allowed disabled:opacity-50',
            {
              'border-gray-700 font-bold text-gray-700':
                selectedCategories?.length === 0,
              'bg-[#F2F2F2]': (selectedCategories ?? [])?.length > 0,
            },
          )}
        >
          {t`All Deals`}
        </button>
        {categories.map((c) => {
          // Fixed Filters should always appear selected and be disabled
          const isFixedFilter =
            fixedFilters.categoryIds?.includes(c.id) ||
            fixedFilters.categories?.includes(c.name);
          // Selected Categories includes the fixed category filter
          const isCategorySelected =
            selectedCategories?.some((s) => s.id === c.id) || isFixedFilter;

          return (
            <button
              disabled={isFixedFilter}
              key={c.id}
              onClick={() => toggleFilter(FilterType.CATEGORY, c.id, c.name)}
              className={classNames(
                'h-8 shrink-0 whitespace-nowrap rounded-full border   px-4 text-xs hover:border-gray-700 disabled:cursor-not-allowed disabled:opacity-50',
                {
                  'border-gray-700 font-bold text-gray-700': isCategorySelected,
                  'bg-[#F2F2F2]': !isCategorySelected,
                },
              )}
            >
              {c.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryFilters;
